


























import Vue from 'vue'
import { mapGetters } from 'vuex'
import Tabs from '../Tabs/Tabs.vue'
import QueryModal from './QueryModal.vue'
import User from '../User/User.vue'

export default Vue.extend({
  name: 'Header',
  components: {
    Tabs,
    QueryModal,
    User
  },
  props: {
    previousLink: {
      type: String,
      default: '/check'
    }
  },
  data: () => {
    return {
      dialog: false
    }
  },
  computed: {
    ...mapGetters('results', ['getChecksCounter']),
    ...mapGetters('results', {
      headerInfo: 'getHeaderInfo'
    })
  }
})
